import React, { useContext, useState } from "react";
import { AppContext } from "../../../context";
import { Typography } from "antd";
function UrbanMobilityText(props) {
  const info = useContext(AppContext);
  const [ellipsis, setEllipsis] = useState(true);
  const [toggle, setToggle] = useState(false);

  const { Paragraph, Text } = Typography;

  return (
    <div style={{ textAlign: "center", padding: "10px 20px 0px 0px" }}>
      <div style={{ marginTop: 10 }}>
        <strong>{info.t("freeService").toUpperCase()}</strong>
      </div>
      <div style={{ width: 400, textAlign: "left", marginTop: 20 }}>
        <Paragraph
          ellipsis={
            ellipsis
              ? {
                  rows: 5,
                  expandable: true,
                  symbol: info.t("more"),
                }
              : false
          }
          key={toggle}
        >
          {/* {info.t("carPhrase")} */}
          <b>Projeto piloto</b> que tem na génese a criação de um novo{" "}
          <b>serviço de mobilidade sustentável, de natureza gratuita,</b>{" "}
          direcionado para empresas, residentes e visitantes, o qual resulta de
          uma parceria entre a Aldeias Históricas de Portugal – Associação de
          Desenvolvimento Turístico, Renault Portugal e Município do Fundão.
          Esta iniciativa visa contribuir para se alcançar a sustentabilidade
          dos transportes, colocando os utilizadores em primeiro lugar,
          proporcionando-lhes alternativas mais baratas de locomoção, mais
          acessíveis, saudáveis e limpas
          <br />
          Ajude-nos a Reduzir as emissões de gases com efeito de estufa no
          território.
          <br />
          Na rede Aldeias Históricas de Portugal a sustentabilidade está a fazer
          História. <b>Faça parte dela e reserve um carro eléctrico.</b>
          <div
            onClick={() => setToggle(!toggle)}
            style={{ display: "inline", color: "#1890ff", cursor: "pointer" }}
          >
            {info.t("less")}
          </div>
        </Paragraph>
      </div>
    </div>
  );
}

export default UrbanMobilityText;
